<template>
  <div class="container-fluid body-profile">
    <div v-if="totalGrades.length && totalGrades.length != 0">
      <!-- summary -->
      <div v-for="totalGrade in totalGrades" :key="totalGrade.group">
        <div role="tablist">
          <StudentSummary
            class="container-fluid"
            v-bind:groupId="parseInt(totalGrade.group)"
          />

          <!-- dlibrs -->
          <div role="tablist" class="container-fluid">
            <!-- dlibr in student -->
            <div
              v-for="deliberation in findinTotalGrade(
                totalGrade,
                user.deliberations
              )"
              :key="deliberation.id"
            >
              <div>
                <!-- collapse header -->

                <StudentCollapseHeader
                  v-bind:title="deliberation.title"
                  v-bind:totalParticipants="deliberation.total_participants"
                  v-bind:totalComments="deliberation.total_comments"
                  v-bind:deliberation="deliberation.id"
                  v-bind:groupId="parseInt(totalGrade.group)"
                />
                <b-collapse
                  v-bind:id="'accordion-' + deliberation.id"
                  visible
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <section class="px-sm-3">
                    <b-row class="px-sm-3">
                      <b-col
                        class="main-content"
                        cols="12"
                        sm="12"
                        md="6"
                        lg="8"
                      >
                        <!-- content header -->
                        <StudentContentBody
                          v-bind:deliberation="deliberation.id"
                          v-bind:groupId="parseInt(totalGrade.group)"
                        />
                      </b-col>
                      <!-- aside -->
                      <b-col sm="12" md="6" lg="4">
                        <!-- Critères de correction -->
                        <StudentCorrection
                          v-bind:deliberation="deliberation.id"
                          v-bind:groupId="parseInt(totalGrade.group)"
                        />
                        <hr />
                        <!-- Analytique -->
                        <StudentAnalytics
                          v-bind:deliberation="deliberation.id"
                          v-bind:groupId="parseInt(totalGrade.group)"
                        />
                      </b-col>
                    </b-row>
                  </section>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="container py-5">
        <b-card class="message">
          <div class="text-center">
            <b-icon
              icon="clipboard-check"
              font-scale="3"
              animation="fade"
            ></b-icon>
            <h3>
              Il n'y a pas de résultats disponible pour ce participant
            </h3>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @file       Student profile component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import store from "@/store";
import StudentSummary from "@/modules/admin/components/students/summary.vue";
import StudentCorrection from "@/modules/admin/components/students/correction.vue";
import StudentAnalytics from "@/modules/admin/components/students/analytics.vue";
import StudentCollapseHeader from "@/modules/admin/components/students/collapseHeader.vue";
import StudentContentBody from "@/modules/admin/components/students/contentBody.vue";
import { adminStudentMixin } from "@/modules/admin/components/students/mixins";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  /**
   * Before route change.
   * 
   * @param  {string}   to     Destination
   * @param  {string}   from   (Unused)
   * @param  {Object}   next   The action
   */
  beforeRouteEnter(to, from, next) {
    store.dispatch("admin/getUserByID", to.params.id).then(() => {
      store.commit("admin/setTotalGradesFilters", {
        reset: true,
        fields: {
          user: parseInt(to.params.id),
          group: to.params.group ? parseInt(to.params.group) : ""
        }
      });
      store
        .dispatch("admin/getTotalGrades")
        .then(() => {
          next();
        })
        .catch(() => {
          next(vm => {
            vm.$root.$bvToast.toast("Aucun registre trouvé", {
              title: "Erreur",
              variant: "danger"
            });
            vm.$router.push({ name: "home" });
          });
        });
    });
  },
  name: "adminStudentProfile",
  mixins: [adminStudentMixin],
  components: {
    StudentSummary,
    StudentCorrection,
    StudentAnalytics,
    StudentCollapseHeader,
    StudentContentBody
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Total grade.
     * 
     * @param   {Object}    The total grade object
     * @param   {int}       The deliberation ID
     * 
     * @return  {Object}    The total grade
     */
    inTotalGrade(totalGrade, id) {
      return totalGrade.deliberations.find(d => d.deliberation == id);
    },

    /**
     * Find in total grade.
     * 
     * @param   {Object}    The total grade object
     * @param   {Object}    The deliberations object
     * 
     * @return  {Array}     The total grade list
     */
    findinTotalGrade(totalGrade, deliberations) {
      let result = [];
      totalGrade.deliberations.forEach(element => {
        let obj = deliberations.find(d => d.id == element.deliberation);
        if (obj) {
          result.push(obj);
        }
      });

      return result;
    }
  }
};
</script>

<style lang="scss" scoped>
.toggle-trigger[aria-expanded="true"] .bi-chevron-right {
  transform: rotate(90deg);
}
.toggle-trigger .bi-chevron-right {
  transition: 0.3s transform ease-in-out;
}

@media (min-width: 768px) {
  .main-content {
    border-right: 1px solid rgba(0, 0, 0, 0.1);
  }
}

.body-profile {
  margin-top: 1%;
}
</style>
